import React, { useRef } from 'react'

const ScrollContext = React.createContext({})

const ScrollContextProvider = props => {
    const scrollbarRef = useRef()
    const scrollableContainerRef = useRef()
    return <ScrollContext.Provider value={{ scrollbarRef, scrollableContainerRef }}>{props.children}</ScrollContext.Provider>
}

export { ScrollContext, ScrollContextProvider }
